import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './resources';
import Logger from '../logger';

const DEFAULT_LANGUAGE = 'en-US';

export const AVAILABLE_LANGUAGES: { [index: string]: string } = {
    'en-US': 'English (United States)',
    'ja-JP': 'Japanese (Japan) / 日本語'
};

const getLanguage = () => {
    const storedLanguage = localStorage.getItem('user-lng');
    if (storedLanguage) return storedLanguage;

    const browserLanguage = navigator.language;
    if (Object.values(AVAILABLE_LANGUAGES).includes(navigator.language))
        return browserLanguage;

    return DEFAULT_LANGUAGE;
};

i18n.use(initReactI18next)
    .init({
        resources,
        lng: getLanguage(),
        interpolation: {
            escapeValue: false
        },
        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['strong', 'code', 'a']
        }
    })
    .then(() => Logger.info('Translation module initialized'))
    .catch((err) =>
        Logger.error('Failed to initialize translation module', err)
    );

export default i18n;
